module.exports = __webpack_public_path__ + "img/estrada-parque-piraputanga.d5811762.jpg";